import dayjs, { Dayjs } from "utils/dayjs"
import { IApiLink, Lmid, Guid } from "@/types"
import { ApiLinkEntity, ApiLinkRel } from "config/constants"
import { getValuationStatusLabel } from "utils/utils"

export enum ValuationStatus {
    active = "active",
    missingParameters = "missingparameters",
    noInvoiceBooked = "noinvoicebooked",
    disposal = "disposal",
}

export enum ValuationsSortBy {
    assetCreatedOn = "assetCreatedOn",
    availabilityDate = "availabilityDate",
}

export interface IGetValuationDto {
    valuationParameterId?: Guid
    lmid: Lmid
    assetId: Guid
    articleId: Guid
    isAssetLabeled: boolean
    hasAssetNewVersion: boolean
    linkedToAssetCollection?: boolean
    articleDescription: string
    availabilityDate?: string | null
    acquisitionDate?: string | null
    depreciationPeriod?: number
    isIfrsPeriodManuallySet?: boolean
    ifrsPeriodChangedBy?: string
    ifrsPeriodChangedOn?: string
    ifrsPeriodComment?: string
    disposalDate?: string
    status?: string
    assetCreatedOn?: string
    links?: IApiLink[]
}

export default class Valuation {
    valuationParameterId?: Guid
    lmid: Lmid
    assetId: Guid
    articleId: Guid
    isAssetLabeled: boolean
    hasAssetNewVersion: boolean
    linkedToAssetCollection: boolean
    articleDescription: string
    availabilityDate?: Dayjs
    acquisitionDate?: Dayjs
    depreciationPeriod?: number
    isIfrsPeriodManuallySet: boolean
    ifrsPeriodChangedBy?: string
    ifrsPeriodChangedOn?: Dayjs
    ifrsPeriodComment?: string
    disposalDate?: Dayjs
    status?: ValuationStatus
    assetCreatedOn?: Dayjs
    createValuationParameterLink?: IApiLink

    constructor({
        valuationParameterId,
        lmid,
        assetId,
        articleId,
        articleDescription,
        isAssetLabeled,
        hasAssetNewVersion,
        linkedToAssetCollection,
        availabilityDate,
        acquisitionDate,
        depreciationPeriod,
        isIfrsPeriodManuallySet,
        ifrsPeriodChangedBy,
        ifrsPeriodChangedOn,
        ifrsPeriodComment,
        disposalDate,
        status,
        assetCreatedOn,
        links
    }: IGetValuationDto) {
        this.valuationParameterId = valuationParameterId
        this.lmid = lmid
        this.assetId = assetId
        this.articleId = articleId
        this.isAssetLabeled = isAssetLabeled
        this.hasAssetNewVersion = hasAssetNewVersion
        this.linkedToAssetCollection = linkedToAssetCollection || false
        this.articleDescription = articleDescription
        this.availabilityDate = availabilityDate ? dayjs(availabilityDate, "YYYY-MM-DD") : undefined
        this.acquisitionDate = acquisitionDate ? dayjs(acquisitionDate, "YYYY-MM-DD") : undefined
        this.depreciationPeriod = depreciationPeriod
        this.isIfrsPeriodManuallySet = isIfrsPeriodManuallySet ?? false
        this.ifrsPeriodChangedBy = ifrsPeriodChangedBy
        this.ifrsPeriodChangedOn = ifrsPeriodChangedOn ? dayjs(ifrsPeriodChangedOn) : undefined
        this.ifrsPeriodComment = ifrsPeriodComment
        this.disposalDate = disposalDate ? dayjs(disposalDate, "YYYY-MM-DD") : undefined
        this.status = status ? status.toLowerCase() as ValuationStatus : undefined
        this.assetCreatedOn = assetCreatedOn ? dayjs(assetCreatedOn, "YYYY-MM-DD") : undefined
        this.createValuationParameterLink = links?.find(lnk => lnk.entity === ApiLinkEntity.valuationParameter && lnk.rel === ApiLinkRel.new)
    }

    get isActive() {
        return this.status === ValuationStatus.active
    }

    get isDisposal() {
        return this.status === ValuationStatus.disposal
    }

    get statusLabel() {
        return !!this.status ? getValuationStatusLabel(this.status) : ""
    }
}
